var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBrush = function SvgBrush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.19 19.563c.435-.596.42-1.41-.036-1.99L12.59 7.165a3.579 3.579 0 0 0-.612-1.33c-.603-.812-1.578-1.388-2.927-1.53-1.07-.112-1.52-.54-1.617-.956a.81.81 0 0 0-1.48-.234c-.471.78-1.063 1.96-1.218 3.282-.16 1.359.144 2.863 1.45 4.169.74.74 1.592 1.123 2.433 1.206l10.266 8.146c.734.54 1.768.381 2.306-.355zM11.057 8.229a2.173 2.173 0 0 1-1.37 1.807c-.687.266-1.564.18-2.359-.614-.9-.9-1.1-1.886-.987-2.836.06-.51.21-1.01.401-1.47.582.467 1.36.716 2.139.798.955.1 1.496.48 1.798.885.316.425.428.956.378 1.43z",
    fill: "#fff"
  })));
};
export default SvgBrush;